export const initialState = {
  data: [],
  error: false,
  isFetched: false,
  isFetching: false,
  messages: {}
}

export const ACTION_TYPES = {
  BROKERS_REQUEST: 'BROKERS_REQUEST',
  BROKERS_SUCCESS: 'BROKERS_SUCCESS',
  BROKERS_ERROR: 'BROKERS_ERROR',
  BROKERS_CLEAR: 'BROKERS_CLEAR'
}

export const getBrokers = (payload = {}) => ({
  type: ACTION_TYPES.BROKERS_REQUEST,
  payload
})

export const clearBrokers = () => ({
  type: ACTION_TYPES.BROKERS_CLEAR
})

const brokers = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.BROKERS_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.BROKERS_SUCCESS:
      return {
        ...state,
        data: payload,
        error: false,
        isFetched: true,
        isFetching: false,
        messages: payload.messages
      }
    case ACTION_TYPES.BROKERS_ERROR:
      return {
        ...state,
        error: true,
        isFetched: true,
        isFetching: false
      }
    case ACTION_TYPES.BROKERS_CLEAR:
      return {
        ...initialState
      }
    default:
      return state
  }
}

export default brokers
